<div class="layout-footer">
  <div class="footer-copyright">© {{ 'footer.copyright' | translate: { date: date | date: 'yyyy' } }}</div>
  <div class="footer-links">
    @if (store.environment(); as environment) {
      <div class="footer-link">
        {{ environment.pomVersion }} (Build {{ environment.buildNumber }}, {{ environment.buildTime | date: 'dd.MM.yyyy HH:mm:ss' }}),
        {{ packageVersion }} (Build {{ packageBuildNumber }}, {{ packageBuildDate | date: 'dd.MM.yyyy HH:mm:ss'}})
      </div>
    }
  </div>
</div>
